<template>
  <div>
    <v-text-field
      append-icon="mdi-magnify"
      label="Buscar"
      hide-details
      outlined
      dense
      color="primary"
      v-model="search"
      :input="$emit('input', search)"
      class="ma-0"
    ></v-text-field>
  </div>
</template>

<script>
export default {
  name: 'TheSearchInput',
  data: () => ({
    search: null,
  }),
}
</script>

<style></style>
